import { useEffect } from "react";
import "./ExcluirDesvio.css";

export default function ExcluirDesvio({
  open,
  titulo,
  descricao,
  onClose,
  onConfirmar,
  onConfirm,
}) {
  if (!open) return null;

  const submit = onConfirmar || onConfirm || (() => {});

  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, []);

  const handleKeyDown = (e) => {
    if (e.key === "Escape") onClose?.();
    if (e.key === "Enter") submit();
  };

  return (
    <div className="dvdel-bg" onKeyDown={handleKeyDown}>
      <div className="dvdel-box" role="dialog" aria-modal="true" aria-label="Excluir desvio">
        <header className="dvdel-head">
          <h3 className="dvdel-title">Excluir</h3>
          <button className="dvdel-x" type="button" onClick={onClose} aria-label="Fechar">x</button>
        </header>

        <div className="dvdel-body">
          {descricao ? descricao : <>Tem certeza que deseja <strong>excluir</strong> "{titulo || "este item"}"?</>}
        </div>

        <footer className="dvdel-foot">
          <button className="dvdel-btn" type="button" onClick={onClose}>Cancelar</button>
          <button className="dvdel-btn dvdel-btn-danger" type="button" onClick={submit}>Excluir</button>
        </footer>
      </div>
    </div>
  );
}
